
<template>
  <div>
    <van-nav-bar
      title="常用预约"
      fixed
      placeholder
      left-text="返回"
      left-arrow
      @click-left="goBack"
    />
    <van-notice-bar
      left-icon="volume-o"
      wrapable
      :scrollable="false"
      text="这里是您常用的座位或研讨间，您可直接预约。"
    />
    <div class="mx-2 mt-1 p-1 bg-white rounded-sm">
      <div class="mt-2">
        <van-tabs type="card" color="#49cfd4">
          <van-tab title="常用座位" v-if="enableSeat">
            <div class="mt-2" v-if="favoriteSeats.length > 0">
              <van-cell-group>
                <van-cell
                  center
                  :title="booking.spaceinfo[0].nameMerge + booking.spaceName"
                  v-for="booking in favoriteSeats"
                  :key="booking.id"
                >
                  <template #right-icon>
                    <van-button
                      color="#49cfd4"
                      size="small"
                      @click="selectBooking(booking)"
                      >预约</van-button
                    >
                  </template>
                </van-cell>
              </van-cell-group>
            </div>
            <van-empty description="暂无数据" v-else />
          </van-tab>
          <van-tab title="常用研讨间" v-if="enableRoom">
            <div class="mt-2" v-if="favoriteRooms.length > 0">
              <van-cell-group>
                <van-cell
                  center
                  :title="booking.spaceinfo[0].nameMerge + booking.spaceName"
                  v-for="booking in favoriteRooms"
                  :key="booking.id"
                >
                  <template #right-icon>
                    <van-button
                      color="#49cfd4"
                      size="small"
                      @click="goBookingRoom(booking)"
                      ><span class="whitespace-nowrap">预约</span></van-button
                    >
                  </template>
                </van-cell>
              </van-cell-group>
            </div>
            <van-empty description="暂无数据" v-else />
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <van-dialog
      v-model:show="bookingShown"
      title="选择日期"
      show-cancel-button
      @confirm="book"
    >
      <div class="mt-2 overflow-x-auto flex space-x-1" v-if="days.length > 0">
        <van-button
          round
          plain
          v-for="(sday, idx) in days"
          :key="sday"
          :class="{ selected: sday === selectedDay }"
          @click="selectDay(sday)"
          ><span class="text-[10px] whitespace-nowrap"
            >{{ idx == 0 ? "今天" : idx == 1 ? "明天" : "" }}({{ sday }})</span
          ></van-button
        >
      </div>
      <van-empty description="无可预约日期" v-else />
      <div
        class="overflow-x-auto flex justify-center mt-1 mb-2 space-x-px"
        v-if="times.length > 0"
      >
        <van-button
          round
          plain
          v-for="time in times"
          :key="time.id"
          :disabled="!time.isValid"
          :class="{ selected: time.id === selectedTime.id }"
          class="whitespace-nowrap"
          @click="selectTime(time)"
          >{{ time.startTime }}-{{ time.endTime }}</van-button
        >
      </div>
      <van-empty description="无可预约时间" v-else />
    </van-dialog>
  </div>
</template>

<script>
import { toRefs, reactive, watch, onMounted } from "vue";
import { useRouter } from "vue-router";
import { Dialog, Toast } from "vant";
import dayjs from "dayjs";
import _ from "lodash";
import qs from "qs";
import {
  getFavoriteBookings,
  getOpenDays,
  getOpenTime,
  getServerTime,
  bookSeat,
} from "@/service/home";
import { myStorage } from "@/utils/util";
import Cookies from "js-cookie";
export default {
  name: "bookFavorite",
  components: {},
  setup() {
    const enableRoom = JSON.parse(Cookies.get("school")).enableRoom;
    const enableSeat = JSON.parse(Cookies.get("school")).enableSeat;
    const user = JSON.parse(Cookies.get("user"));
    const router = useRouter();
    const state = reactive({
      favoriteSeats: [],
      favoriteRooms: [],
      days: [],
      times: [],
      rawDays: [],
      selectedDay: "",
      selectedTime: "",
      selectedBooking: {},
      enableRoom: enableRoom,
      enableSeat: enableSeat,
      bookingShown: false,
      openTime: {},
    });
    const goBack = () => router.go(-1);
    const selectDay = function (day) {
      state.selectedDay = day;
    };
    const selectTime = (time) => {
      state.selectedTime = time;
    };
    const selectBooking = async (booking) => {
      state.selectedBooking = booking;
      try {
        const {
          data: { list },
        } = await getOpenDays(booking.spaceinfo[0].id);
        state.rawDays = list;
        state.days = _.uniq(_.map(list, "day"));
        state.selectedDay = state.days[0];
        state.bookingShown = true;
      } catch (err) {
        state.days = [];
      }
    };
    const goBookingRoom = async (booking) => {
      myStorage.set("room", booking.spaceinfo[0]);
      const allSeats = myStorage.get("allSeats");
      const floor = _.find(allSeats, { id: booking.spaceinfo[0].parentId });
      const library = _.find(allSeats, { id: floor.parentId });
      myStorage.set("library", library);
      router.push("/bookRoom");
    };
    const book = async () => {
      const serverTime = await getServerTime();
      const now = dayjs.unix(serverTime / 29 - 509).format("HH:mm");
      if (state.openTime.beginTime) {
        if (state.openTime.endTime) {
          if (now < state.openTime.beginTime || now > state.openTime.endTime) {
            Toast.fail(
              "预约开放时间：\n" +
                state.openTime.beginTime +
                "-" +
                state.openTime.endTime
            );
            return false;
          }
        } else {
          if (now < state.openTime.beginTime) {
            Toast.fail(
              "预约开放时间：\n" +
                state.openTime.beginTime +
                "-" +
                state.openTime.endTime
            );
            return false;
          }
        }
      }
      const access_token = user.access_token;
      try {
        const {
          data: { list },
          status,
          msg,
        } = await bookSeat(
          state.selectedBooking.spaceId,
          qs.stringify({
            access_token: access_token,
            userid: user.userid,
            segment: state.selectedTime.id,
            type: 1,
            operateChannel: 3,
          })
        );
        if (status === 0) {
          throw new Error(msg);
        }
        let violation = list.renegeinfo ? list.renegeinfo.count : null;
        violation = violation ? "提醒：" + violation : "";
        Dialog.alert({
          title: "预约成功",
          allowHtml: true,
          messageAlign: "left",
          message:
            "区域：" +
            list.spaceInfo.areaInfo.nameMerge +
            list.spaceInfo.name +
            "\n" +
            "时间：" +
            state.selectedDay +
            " " +
            state.selectedTime.startTime +
            "-" +
            state.selectedTime.endTime +
            "\n" +
            '<p class="text-red-800">' +
            violation +
            "</p>",
        }).then(() => {
          router.push("/mySeatBookings");
        });
      } catch (err) {
        if (err.message.indexOf("undefined") > -1) {
          err.message = "系统繁忙,请稍后再试";
        } else {
          Toast({
            message: err.message,
            forbidClick: true,
            overlay: true,
          });
        }
      }
    };
    watch(
      () => state.selectedDay,
      async (newValue) => {
        try {
          state.times = _.map(
            _.filter(state.rawDays, { day: newValue }),
            (day) => {
              return {
                id: day.id,
                startTime: day.startTime.date.slice(11, 16),
                endTime: day.endTime.date.slice(11, 16),
                isValid: dayjs().isBefore(
                  dayjs([day.day, day.endTime.date.slice(11)].join(" "))
                ),
              };
            }
          );
          if (state.times.length > 0) {
            let validTimes = _.filter(state.times, { isValid: true });
            state.selectedTime = validTimes.length > 0 ? validTimes[0] : "";
          }
        } catch (err) {
          state.times = [];
        }
      }
    );
    onMounted(async () => {
      try {
        state.openTime = await getOpenTime();
        const {
          data: { list },
        } = await getFavoriteBookings(user.userid);
        if (list) {
          state.favoriteSeats = list.filter(
            (booking) => booking.spaceType === 1
          );
          state.favoriteRooms = list.filter(
            (booking) => booking.spaceType === 2
          );
        }
      } catch (error) {
        if (error instanceof TypeError) {
          Toast({
            message: "暂无数据",
            forbidClick: true,
            overlay: true,
          });
        } else {
          Toast({
            message: "系统繁忙，请稍后再试",
            forbidClick: true,
            overlay: true,
          });
        }
      }
    });
    return {
      goBack,
      selectDay,
      selectTime,
      selectBooking,
      goBookingRoom,
      book,
      ...toRefs(state),
    };
  },
};
</script>

<style lang="less" scoped>
@import "../common/style/base";
.selected {
  background-color: #49cfd4;
  color: white;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}
</style>
